import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "indicators", "leftControl", "rightControl", "slide", "slideInterval", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Children, cloneElement, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi';
import ScrollContainer from 'react-indiana-drag-scroll';
import windowExists from '../../helpers/window-exists';
import { useTheme } from '../Flowbite/ThemeContext';
export var Carousel = function Carousel(_ref) {
  var children = _ref.children,
    _ref$indicators = _ref.indicators,
    indicators = _ref$indicators === void 0 ? true : _ref$indicators,
    leftControl = _ref.leftControl,
    rightControl = _ref.rightControl,
    _ref$slide = _ref.slide,
    slide = _ref$slide === void 0 ? true : _ref$slide,
    slideInterval = _ref.slideInterval,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var isDeviceMobile = windowExists() && navigator.userAgent.indexOf('IEMobile') !== -1;
  var carouselContainer = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeItem = _useState2[0],
    setActiveItem = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDragging = _useState4[0],
    setIsDragging = _useState4[1];
  var theme = useTheme().theme.carousel;
  var items = useMemo(function () {
    return Children.map(children, function (child) {
      return cloneElement(child, {
        className: classNames(theme.item.base, child.props.className)
      });
    });
  }, [children, theme.item.base]);
  var navigateTo = useCallback(function (item) {
    return function () {
      if (!items) return;
      item = (item + items.length) % items.length;
      if (carouselContainer.current) {
        carouselContainer.current.scrollLeft = carouselContainer.current.clientWidth * item;
      }
      setActiveItem(item);
    };
  }, [items]);
  useEffect(function () {
    if (carouselContainer.current && !isDragging && carouselContainer.current.scrollLeft !== 0) {
      setActiveItem(Math.round(carouselContainer.current.scrollLeft / carouselContainer.current.clientWidth));
    }
  }, [isDragging]);
  useEffect(function () {
    if (slide) {
      var intervalId = setInterval(function () {
        return !isDragging && navigateTo(activeItem + 1)();
      }, slideInterval !== null && slideInterval !== void 0 ? slideInterval : 3000);
      return function () {
        return clearInterval(intervalId);
      };
    }
  }, [activeItem, isDragging, navigateTo, slide, slideInterval]);
  var handleDragging = function handleDragging(dragging) {
    return function () {
      return setIsDragging(dragging);
    };
  };
  return _jsxs("div", _objectSpread(_objectSpread({
    className: classNames(theme.base, className),
    "data-testid": "carousel"
  }, props), {}, {
    children: [_jsx(ScrollContainer, {
      className: classNames(theme.scrollContainer.base, (isDeviceMobile || !isDragging) && theme.scrollContainer.snap),
      draggingClassName: "cursor-grab",
      innerRef: carouselContainer,
      onEndScroll: handleDragging(false),
      onStartScroll: handleDragging(true),
      vertical: false,
      children: items === null || items === void 0 ? void 0 : items.map(function (item, index) {
        return _jsx("div", {
          className: theme.item.wrapper,
          "data-active": activeItem === index,
          "data-testid": "carousel-item",
          children: item
        }, index);
      })
    }), indicators && _jsx("div", {
      className: theme.indicators.wrapper,
      children: items === null || items === void 0 ? void 0 : items.map(function (_, index) {
        return _jsx("button", {
          className: classNames(theme.indicators.base, theme.indicators.active[index === activeItem ? 'on' : 'off']),
          onClick: navigateTo(index),
          "data-testid": "carousel-indicator"
        }, index);
      })
    }), items && _jsxs(_Fragment, {
      children: [_jsx("div", {
        className: theme.leftControl,
        children: _jsx("button", {
          className: "group",
          "data-testid": "carousel-left-control",
          onClick: navigateTo(activeItem - 1),
          type: "button",
          children: leftControl ? leftControl : _jsx(DefaultLeftControl, {})
        })
      }), _jsx("div", {
        className: theme.rightControl,
        children: _jsx("button", {
          className: "group",
          "data-testid": "carousel-right-control",
          onClick: navigateTo(activeItem + 1),
          type: "button",
          children: rightControl ? rightControl : _jsx(DefaultRightControl, {})
        })
      })]
    })]
  }));
};
var DefaultLeftControl = function DefaultLeftControl() {
  var theme = useTheme().theme.carousel;
  return _jsx("span", {
    className: theme.control.base,
    children: _jsx(HiOutlineChevronLeft, {
      className: theme.control.icon
    })
  });
};
var DefaultRightControl = function DefaultRightControl() {
  var theme = useTheme().theme.carousel;
  return _jsx("span", {
    className: theme.control.base,
    children: _jsx(HiOutlineChevronRight, {
      className: theme.control.icon
    })
  });
};